import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Image, Modal, Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ComponentLoader from "../../layout/ComponentLoader";
import { apiGetPersonne } from "../../../api/ApiPersonnes";
import {
  apiGetAllContribByUsersByEspaces,
  apiGetLastContribByUsers,
} from "../../../api/ApiColidee";
import { selectReduxInstance } from "../../../redux/ReduxInstance";
import {
  MdPhoneIphone,
  MdEmail,
  MdLocationOn,
  MdAccountBox,
  MdDescription,
  MdOutlineCategory,
} from "react-icons/md";
import { toDateTimeFR } from "../../../utils/datesHeures";
import genericAvatar from "../../../assets/images/generic-avatar.jpeg";
import { apiGetProcesses } from "../../../api/ApiProcess";
import icon_colidee from "../../../assets/images/tools/icon_colidee.png";
import icon_teams from "../../../assets/images/tools/icon_teams.png";
import ComponentThemesContribution from "../colidee/ComponentThemesContribution";
import ModalChoixOrgunits from "../../admin/personne/ModalChoixOrgunits";
import ComponentRangeSlider from "../../layout/ComponentRangeSlider";

import { forceRefreshData } from "../../../redux/ReduxRefresh";
import { FaRegQuestionCircle } from "react-icons/fa";

const ModalDetailPersonne = (props) => {
  const { t } = useTranslation();
  const { id, show, handleClose } = props;
  const dispatch = useDispatch();
  const [personne, setPersonne] = useState("");
  const [lastContrib, setLastContrib] = useState("");
  const [lastContribOnAllEspace, setLastContribOnAllEspace] = useState("");
  const ReduxInstance = useSelector(selectReduxInstance);
  const { ReduxRefresh } = useSelector((state) => state.ReduxRefresh);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);
  const { ReduxToken } = useSelector((state) => state.ReduxToken);
  const [showEditGroup, setShowEditGroup] = useState(false);

  useEffect(() => {
    if (show) {
      // On recupère les informations de la personne uniquement quand on affiche la modale
      recupPersonne();
    }
  }, [show, ReduxRefresh]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (personne && ReduxInstance.espacePrincipalColidee !== 0) {
      recupLastContrib(personne.email);
    }

    if (personne) {
      recupAllContributionsForUsersOnAllEspaces(personne.email);
    }
  }, [personne]); // eslint-disable-line react-hooks/exhaustive-deps

  const recupPersonne = async () => {
    const res = await apiGetPersonne(
      ReduxInstance._id,
      id,
      "include=orgUnitsParent,marque,localisations"
    );
    if (res) {
      res.data.localisations.sort((a, b) => (a.nom > b.nom ? 1 : b.nom > a.nom ? -1 : 0));
      setPersonne(res.data);
    } else {
      console.log("error");
    }
  };

  const recupLastContrib = async (email) => {
    if (email) {
      const myForm = new FormData();
      myForm.append("espacePrincipalColidee", ReduxInstance.espacePrincipalColidee);
      myForm.append("email[]", [email]);
      const res = await apiGetLastContribByUsers(ReduxToken, myForm);
      if (res) {
        if (res.data.length) {
          setLastContrib(res.data[0]);
        } else {
          setLastContrib("pasdecontrib");
        }
      } else {
        console.log("error");
      }
    }
  };

  const recupAllContributionsForUsersOnAllEspaces = async (email) => {
    if (email) {
      const myForm = new FormData();
      myForm.append("email[]", email);

      var espacesSouhaites = [];
      const resProcesses = await apiGetProcesses(ReduxInstance._id, "filter[famille]=MacroProcess");
      resProcesses.data.map(
        (process) => (espacesSouhaites = espacesSouhaites.concat(process.espaces))
      );
      espacesSouhaites = espacesSouhaites.filter((x, i, a) => a.indexOf(x) === i);

      /* Si j'ai un espace RDV missions alors je ne le prends pas en compte pour trouver la derniere contrib sur tous les espaces */
      if (ReduxInstance.espacePrincipalColidee !== 0) {
        espacesSouhaites = espacesSouhaites.filter(
          (item) => parseInt(item) !== ReduxInstance.espacePrincipalColidee
        );
      }

      myForm.append("espacesSouhaites", espacesSouhaites.join(","));
      const resAllContributions = await apiGetAllContribByUsersByEspaces(ReduxToken, myForm);

      if (resAllContributions) {
        if (resAllContributions.data.length) {
          setLastContribOnAllEspace(resAllContributions.data[0]);
        } else {
          setLastContribOnAllEspace("pasdecontrib");
        }
      } else {
        console.log("error");
      }
    } else {
      setLastContribOnAllEspace("pasdecontrib");
    }
  };

  const filterProcesses = (orgunits, orgName) => {
    if (!orgName) {
      return orgunits;
    }

    if (Array.isArray(orgName)) {
      return orgunits.filter((org) => {
        const types = Array.isArray(org.type) ? org.type : [org.type];
        return types.some((t) => orgName.includes(t)) && !org.enSommeil;
      });
    } else {
      return orgunits.filter((org) => {
        return org.type.includes(orgName) && !org.enSommeil;
      });
    }
  };

  const afficheNonRenseigne = (rituels) => {
    let afficheTitre = t("public.componentPersonne.nonRenseigne");
    rituels.map((elem, key) => {
      if (elem.orgUnitParent !== ReduxInstance.orgunitPrincipalInOperation) {
        afficheTitre = "";
      }
    });

    return afficheTitre;
  };

  const afficheNonRenseigneScope = (rituels, scope) => {
    let afficheTitre = t("public.componentPersonne.nonRenseigne");
    rituels.map((elem, key) => {
      if (
        elem.orgUnitParent === ReduxInstance.orgunitPrincipalInOperation &&
        elem.scope === scope
      ) {
        afficheTitre = "";
      }
    });

    return afficheTitre;
  };

  /* UTILE POUR LES ADMINISTRATEURS */
  const isAdminEasygouv = () => {
    // si je suis souscripteur
    if (ReduxUserEmail === ReduxInstance.souscripteur) return true;
    // si je suis dans le tableau des adminProcessAccess
    if (ReduxInstance.adminProcessAccess.indexOf(ReduxUserEmail) > -1) return true;

    return false;
  };

  const handleCloseEditGroup = () => {
    dispatch(forceRefreshData());
    setShowEditGroup(false);
  };

  const retourneLettresMBTI = () => {
    let profil = "";

    profil += personne.lettresMbti[0] > 50 ? "I" : "E";
    profil += personne.lettresMbti[1] > 50 ? "N" : "S";
    profil += personne.lettresMbti[2] > 50 ? "F" : "T";
    profil += personne.lettresMbti[3] > 50 ? "P" : "J";

    return (
      <a
        href={process.env.REACT_APP_URL_EASYGOUV + "profilsMBTI/" + profil + ".pdf"}
        target="_blank"
        rel="noreferrer"
        className="d-flex"
      >
        <Image
          width={250}
          src={process.env.REACT_APP_URL_EASYGOUV + "profilsMBTI/" + profil + ".png"}
        />
        <FaRegQuestionCircle size=".8em" className="ms-2" color="#CCC" />
      </a>
    );
  };

  return (
    <>
      {show && (
        <Modal size="lg" show={show} onHide={handleClose} className="modalPersonne">
          <Modal.Header closeButton>
            <Modal.Title>{t("public.componentPersonne.modalTitle")}</Modal.Title>
            {isAdminEasygouv() && (
              <div className="flex-grow-1 text-end">
                <MdOutlineCategory
                  size="1.5em"
                  role="button"
                  onClick={() => setShowEditGroup(true)}
                  className=""
                />
                <ModalChoixOrgunits
                  show={showEditGroup}
                  idPersonne={personne._id}
                  handleClose={handleCloseEditGroup}
                  ReduxInstanceId={ReduxInstance._id}
                />
              </div>
            )}
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex flex-wrap justify-content-center">
              <Image
                className="avatarBig"
                src={
                  personne.profilePic
                    ? process.env.REACT_APP_URL_EXPRESS + "images/avatar/" + personne.profilePic
                    : genericAvatar
                }
              />

              <span className="flex-grow-1 p-2">
                <h2>
                  {personne.prenom + " " + personne.nom}{" "}
                  {personne.email && (
                    <div className="float-end">
                      <a
                        style={{ marginRight: 8 }}
                        href={
                          process.env.REACT_APP_URL_COLIDEE +
                          "/redirectMailColideurToIdProfile?email=" +
                          personne.email
                        }
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Image className="icon" src={icon_colidee} />
                      </a>
                      {personne.marque && personne.marque.moduleTeams && (
                        <a
                          href={"https://teams.microsoft.com/l/chat/0/0?users=" + personne.email}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Image className="icon" src={icon_teams} />
                        </a>
                      )}
                    </div>
                  )}
                </h2>
                <p>
                  {t("public.componentPersonne.fromOrganisation")}{" "}
                  {personne.marque ? personne.marque.nom : "-"}
                </p>
                {/* <p>
                  Dans la société {personne.marque ? personne.marque.nom : "-"} depuis le{" "}
                  {personne.dateEmbauche ? toDateParseFR(personne.dateEmbauche) : "-"}
                </p> */}
                <p>
                  <MdPhoneIphone size="1.5em" className="me-1" />
                  {personne.telephone ? (
                    <a href={`tel:${personne.telephone}`}>{personne.telephone}</a>
                  ) : (
                    "-"
                  )}
                </p>
                <p>
                  <MdEmail size="1.5em" className="me-1" />
                  {personne.email ? <a href={`mailto:${personne.email}`}>{personne.email}</a> : "-"}
                </p>
                <p>
                  <MdLocationOn size="1.5em" className="me-1" />

                  {/* {personne.localisations.map((element) => (
                    <p key={element._id}>{element.nom}</p>
                  ))} */}
                  {personne.localisations && personne.localisations.length
                    ? personne.localisations.map((element, key) => (
                        <Link to={"/espaces?localisation=" + element._id} key={element._id}>
                          {key >= 1 ? "," : ""}
                          <span className={key >= 1 ? "ms-1" : ""}>{element.nom}</span>
                        </Link>
                      ))
                    : "-"}
                </p>
                <p>
                  {personne.urlCv ? (
                    <a href={personne.urlCv} target="_blank" rel="noreferrer">
                      <MdDescription size="1.5em" className="me-1" />{" "}
                      {t("public.componentPersonne.cv")}
                    </a>
                  ) : (
                    ""
                  )}
                </p>
                <p>
                  {personne.urlPortrait ? (
                    <a href={personne.urlPortrait} target="_blank" rel="noreferrer">
                      <MdAccountBox size="1.5em" className="me-1" />
                      {t("public.componentPersonne.portrait")}
                    </a>
                  ) : (
                    ""
                  )}
                </p>
              </span>
            </div>

            <div className="mt-3">
              <Tabs defaultActiveKey="missions" className="mb-3 ">
                <Tab eventKey="rituels" title={t("public.componentPersonne.onglet1")}>
                  {personne && (
                    <>
                      {filterProcesses(personne.orgUnitsParent, "Rituel").length ? (
                        <>
                          {t("public.componentPersonne.rituelsGouvernance")}
                          {" : "}
                          <ul>
                            {filterProcesses(personne.orgUnitsParent, "Rituel").map((elem, key) => {
                              if (elem.orgUnitParent !== ReduxInstance.orgunitPrincipalInOperation)
                                return (
                                  <li key={key}>
                                    -{" "}
                                    <Link
                                      to={"/orgunits/" + elem._id}
                                      onClick={(e) => handleClose()}
                                    >
                                      {elem.nom}
                                    </Link>
                                  </li>
                                );
                              return false;
                            })}
                            {afficheNonRenseigne(
                              filterProcesses(personne.orgUnitsParent, "Rituel")
                            )}
                          </ul>
                        </>
                      ) : (
                        <>
                          {t("public.componentPersonne.rituelsGouvernance")}
                          <ul>
                            <li>{t("public.componentPersonne.nonRenseigne")}</li>
                          </ul>
                        </>
                      )}

                      {filterProcesses(personne.orgUnitsParent, "Temps collectif").length ? (
                        <>
                          {t("public.componentPersonne.tempsCollectifs")} :
                          <ul>
                            {filterProcesses(personne.orgUnitsParent, "Temps collectif").map(
                              (elem, key) => {
                                if (
                                  elem.orgUnitParent !== ReduxInstance.orgunitPrincipalInOperation
                                )
                                  return (
                                    <li key={key}>
                                      -{" "}
                                      <Link
                                        to={"/orgunits/" + elem._id}
                                        onClick={(e) => handleClose()}
                                      >
                                        {elem.nom}
                                      </Link>
                                    </li>
                                  );
                                return false;
                              }
                            )}
                            {afficheNonRenseigne(
                              filterProcesses(personne.orgUnitsParent, "Temps collectif")
                            )}
                          </ul>
                        </>
                      ) : (
                        <>
                          {t("public.componentPersonne.tempsCollectifs")} :
                          <ul>
                            <li>{t("public.componentPersonne.nonRenseigne")}</li>
                          </ul>
                        </>
                      )}
                    </>
                  )}
                </Tab>

                {(ReduxInstance.orgunitPrincipalInOperation ||
                  ReduxInstance.espacePrincipalColidee !== 0) && (
                  <Tab eventKey="missions" title={t("public.componentPersonne.onglet2")}>
                    {ReduxInstance.orgunitPrincipalInOperation && personne && (
                      <>
                        <div> {t("public.componentPersonne.missionsInternes")} : </div>

                        {filterProcesses(personne.orgUnitsParent, ["Rituel", "Mission"]).length ? (
                          <ul>
                            {filterProcesses(personne.orgUnitsParent, ["Rituel", "Mission"]).map(
                              (elem, key) => {
                                if (
                                  elem.orgUnitParent ===
                                    ReduxInstance.orgunitPrincipalInOperation &&
                                  elem.scope === "Interne"
                                )
                                  return (
                                    <li key={key}>
                                      -{" "}
                                      <Link
                                        to={"/orgunits/" + elem._id}
                                        onClick={(e) => handleClose()}
                                      >
                                        {elem.nom}
                                      </Link>
                                    </li>
                                  );
                                return false;
                              }
                            )}
                            {afficheNonRenseigneScope(
                              filterProcesses(personne.orgUnitsParent, ["Rituel", "Mission"]),
                              "Interne"
                            )}
                          </ul>
                        ) : (
                          <ul>
                            <li>{t("public.componentPersonne.nonRenseigne")}</li>
                          </ul>
                        )}

                        <div>{t("public.componentPersonne.missionsExternes")} : </div>
                        {filterProcesses(personne.orgUnitsParent, ["Rituel", "Mission"]).length ? (
                          <ul>
                            {filterProcesses(personne.orgUnitsParent, ["Rituel", "Mission"]).map(
                              (elem, key) => {
                                if (
                                  elem.orgUnitParent ===
                                    ReduxInstance.orgunitPrincipalInOperation &&
                                  elem.scope === "Externe"
                                )
                                  return (
                                    <li key={key}>
                                      -{" "}
                                      <Link
                                        to={"/orgunits/" + elem._id}
                                        onClick={(e) => handleClose()}
                                      >
                                        {elem.nom}
                                      </Link>
                                    </li>
                                  );
                                return false;
                              }
                            )}
                            {afficheNonRenseigneScope(
                              filterProcesses(personne.orgUnitsParent, ["Rituel", "Mission"]),
                              "Externe"
                            )}
                          </ul>
                        ) : (
                          <ul>
                            <li>{t("public.componentPersonne.nonRenseigne")}</li>
                          </ul>
                        )}
                      </>
                    )}

                    {ReduxInstance.espacePrincipalColidee !== 0 && (
                      <>
                        {!lastContrib && personne.email !== "" && <ComponentLoader />}
                        {lastContrib && (
                          <>
                            <div>{t("public.componentPersonne.lastContributionMission")} :</div>
                            {lastContrib.contribution ? (
                              <ul>
                                <li>
                                  {toDateTimeFR(lastContrib.date)}
                                  <br />
                                  <a
                                    href={
                                      process.env.REACT_APP_URL_COLIDEE +
                                      "o" +
                                      lastContrib.id_entreprise +
                                      "p" +
                                      lastContrib.id_plateforme +
                                      "/participation-" +
                                      lastContrib.id_contribution +
                                      ".htm"
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <ComponentThemesContribution contribution={lastContrib} />
                                    {lastContrib.contribution}
                                    {lastContrib.illustrationSmall && (
                                      <>
                                        <br />
                                        <Image
                                          src={lastContrib.illustrationSmall}
                                          style={{ height: "inherit", maxWidth: "inherit" }}
                                        />
                                      </>
                                    )}
                                  </a>
                                </li>
                              </ul>
                            ) : (
                              <ul>
                                <li>{t("public.componentPersonne.nonRenseigne")}</li>
                              </ul>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </Tab>
                )}

                <Tab eventKey="roles" title={t("public.componentPersonne.onglet3")}>
                  {personne && (
                    <>
                      {filterProcesses(personne.orgUnitsParent, "Rôle").length ? (
                        <ul>
                          {filterProcesses(personne.orgUnitsParent, "Rôle").map((elem, key) => {
                            return (
                              <li key={key}>
                                -{" "}
                                <Link to={"/orgunits/" + elem._id} onClick={(e) => handleClose()}>
                                  {elem.nom}
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        <ul>
                          <li>{t("public.componentPersonne.nonRenseigne")}</li>
                        </ul>
                      )}
                    </>
                  )}
                </Tab>
                {lastContribOnAllEspace !== "" && (
                  <Tab eventKey="participation" title={t("public.componentPersonne.onglet4")}>
                    {!lastContribOnAllEspace && <ComponentLoader />}
                    {lastContribOnAllEspace && (
                      <>
                        <div> {t("public.componentPersonne.lastContributionColidee")} : </div>
                        {lastContribOnAllEspace.contribution ? (
                          <ul>
                            <li>
                              <a
                                href={
                                  process.env.REACT_APP_URL_COLIDEE +
                                  "o" +
                                  lastContribOnAllEspace.id_entreprise +
                                  "p" +
                                  lastContribOnAllEspace.id_plateforme +
                                  "/participation-" +
                                  lastContribOnAllEspace.id_contribution +
                                  ".htm"
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                <ComponentThemesContribution
                                  contribution={lastContribOnAllEspace}
                                />
                                {lastContribOnAllEspace.contribution}
                                {lastContribOnAllEspace.illustrationSmall && (
                                  <>
                                    <br />
                                    <Image
                                      src={lastContribOnAllEspace.illustrationSmall}
                                      style={{ height: "inherit", maxWidth: "inherit" }}
                                    />
                                  </>
                                )}
                                <br />
                                <br />
                                <span className="fst-italic">
                                  {t("public.componentPersonne.postOn")}{" "}
                                  {lastContribOnAllEspace.nomEntreprise} >{" "}
                                  {lastContribOnAllEspace.nomPlateforme} <br />
                                  {toDateTimeFR(lastContribOnAllEspace.date)}
                                </span>
                              </a>
                              <br />
                            </li>
                          </ul>
                        ) : (
                          <ul>
                            <li>{t("public.componentPersonne.nonRenseigne")}</li>
                          </ul>
                        )}
                      </>
                    )}
                  </Tab>
                )}
                {personne.lettresMbti?.length > 0 ? (
                  <Tab
                    eventKey="profilmbti"
                    title={t("public.componentPersonne.onglet5")}
                    className="mb-5"
                  >
                    <h1 className="d-flex justify-content-center">{retourneLettresMBTI()}</h1>
                    <ComponentRangeSlider
                      percentage={personne.lettresMbti?.[0]}
                      leftLabel={t("public.componentPersonne.profilMbtiExtraversion")}
                      rightLabel={t("public.componentPersonne.profilMbtiIntroversion")}
                      color="#4ECDC4"
                      isEditable={false}
                    />
                    <ComponentRangeSlider
                      percentage={personne.lettresMbti?.[1]}
                      leftLabel={t("public.componentPersonne.profilMbtiSensation")}
                      rightLabel={t("public.componentPersonne.profilMbtiIntuition")}
                      color="#F7DC6F"
                      isEditable={false}
                    />
                    <ComponentRangeSlider
                      percentage={personne.lettresMbti?.[2]}
                      leftLabel={t("public.componentPersonne.profilMbtiPensee")}
                      rightLabel={t("public.componentPersonne.profilMbtiSentiment")}
                      color="#7DCEA0"
                      name="lettreMbti3"
                      isEditable={false}
                    />
                    <ComponentRangeSlider
                      percentage={personne.lettresMbti?.[3]}
                      leftLabel={t("public.componentPersonne.profilMbtiJugement")}
                      rightLabel={t("public.componentPersonne.profilMbtiPerception")}
                      color="#BB8FCE"
                      isEditable={false}
                    />
                    {/* <ComponentRangeSlider
                      percentage={personne.lettresMbti?.[4]}
                      leftLabel={t("public.componentPersonne.profilMbtiAssertif")}
                      rightLabel={t("public.componentPersonne.profilMbtiTurbulent")}
                      color="#F1948A"
                      isEditable={false}
                    /> */}
                  </Tab>
                ) : (
                  ""
                )}
              </Tabs>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default ModalDetailPersonne;
